import { CardModel, CardValue, PileCardModel } from "../../interface/game";
import { PileDropPolicy } from "./pile-drop-policy";

export class PileDropCardValuePolicy implements PileDropPolicy {
    constructor(private value: CardValue) {}
    canDrop(pile: PileCardModel[], dropCards: PileCardModel[], cards: {[key: string]: CardModel}): boolean {
        return cards[dropCards[0].id].value === this.value;
    }
}